import template from './assetCommitments.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    assetCommitments: '<',
    assetCommitment: '<',
    lenders: '<',
    index: '<',
    parentIndex: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdUtil, helperService, assetFinanceService, dateTimeService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableProductTypes = [];
      ctrl.availableTermInMonths = [];
      ctrl.activeTab = 0;
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableTermInMonths = helperService.getAvailableTermInMonths({
          isRegular: true
        });
        ctrl.availableProductTypes = assetFinanceService.getAvailableProductTypes({
          isCommercial: true
        });
        ctrl.assetCommitments = ctrl.assetCommitments || [];
        ctrl.assetCommitment = ctrl.assetCommitment || {};
        ctrl.lenders = _.chain(ctrl.lenders)
          .filter((l) => l.type.indexOf('ASSET_FINANCE') > -1)
          .sortNatural('name')
          .sortNatural('group')
          .value();
        ctrl.index = ctrl.index || ctrl.index === 0 ? ctrl.index : -1;
        ctrl.parentIndex = ctrl.parentIndex || ctrl.parentIndex === 0 ? ctrl.parentIndex : -1;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        dateTimeService.getSet(
          ctrl,
          ctrl.assetCommitment,
          'dateTakenOut',
          'getSetDateTakenOut'
        );
        ctrl.isReady = true;
      };

      ctrl.assetCommitmentDelete = ({ assetCommitment }) => {
        const idx = _.findIndex(ctrl.assetCommitments, (a) => a?.id === assetCommitment?.id);
        if (idx > -1) {
          helperService
            .deleteItem(
              ctrl.assetCommitments,
              assetCommitment,
              'Asset commitment schedule',
              `row #${idx + 1}`
            )
            .then((result) => {
              if (result) {
                ctrl.saveAssetCommitments();
              }
            });
        }
      };

      ctrl.isLenderSelected = ({ lenderAbbr }) => {
        if (lenderAbbr) {
          return _.find(ctrl.lenders, (l) => l.abbr.toLowerCase() === lenderAbbr);
        }
        return true;
      };

      /*
       * Save asset commitment schedule
       * --------------------------------------------------------------------------------
       */
      ctrl.saveAssetCommitments = $mdUtil.debounce(() => {
        const data = { assetCommitments: ctrl.assetCommitments, index: ctrl.parentIndex };
        ctrl.onFinished({ data });
      }, 1500);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
